import { InjectionToken } from '@angular/core';

import { AppleDeviceProfileTypeConfig } from './apple-device-profile.types';

/**
 * Injection token for providing profile type configurations.
 * Use this token to register profile types in your module.
 *
 * @example
 * ```typescript
 * @NgModule({
 *   providers: [
 *     {
 *       provide: APPLE_DEVICE_PROFILE_CONFIGS,
 *       useFactory: (appleDevicesService: AppleDevicesService) => [
 *         {
 *           profileType: 'certificate',
 *           apiFn: (udid) => appleDevicesService.getCertificates(udid, '2.0'),
 *           isMultiItem: true,
 *           getItemId: (cert) => cert.commonName,
 *         },
 *         // ... more configs
 *       ],
 *       deps: [AppleDevicesService],
 *     },
 *   ],
 * })
 * export class AppModule {}
 * ```
 */
export const APPLE_DEVICE_PROFILE_CONFIGS = new InjectionToken<AppleDeviceProfileTypeConfig[]>(
  'Apple Device Profile Configurations'
);
